"use client";
import { HomeNavbar } from "../common/HomeNavbar";
import { ForgotPasswordForm } from "./ForgotPasswordForm";
import { WelcomeSection } from "../sign-in/WelcomeSection";

export default function ForgotPasswordClient() {
  return (
    <div className="flex min-h-screen flex-col bg-[#fcf5f1]">
      <HomeNavbar />
      <div className="flex grow items-center justify-center px-4 pt-28 pb-12 sm:px-8 lg:px-0">
        <div className="grid w-full max-w-7xl bg-white py-8 shadow-xl rounded-2xl sm:rounded-4xl md:grid-cols-2 lg:p-8">
          <WelcomeSection />
          <ForgotPasswordForm />
        </div>
      </div>
    </div>
  );
}
